import React__default, { useRef, useCallback, useEffect } from 'react';

/* eslint-disable */
function IlDataTableV3ContextMenu(props) {
  var timeoutRef = useRef();
  var closeCallback = useCallback(function (ev) {
    if (ev.key === 'Escape') {
      props.onHide();
    }
  }, []);
  useEffect(function () {
    document.addEventListener('keydown', closeCallback);
    return function () {
      document.removeEventListener('keydown', closeCallback);
    };
  }, [closeCallback]);
  function _renderContextMenuItems() {
    var _final = [];
    if (props.items) {
      props.items.forEach(function (item) {
        _final.push(/*#__PURE__*/React__default.createElement("li", {
          key: "IlDataTableV3ContextMenu-item-".concat(item.title),
          onClick: function onClick(ev) {
            item.onClick(ev, props.data, props.gridApi);
            props.onHide();
          }
        }, item.title));
      });
    }
    return _final;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'IlDataTableV3ContextMenu',
    style: {
      top: props.y + props.offset,
      left: props.x + props.offset
    },
    onMouseLeave: function onMouseLeave() {
      timeoutRef.current = setTimeout(function () {
        props.onHide();
      }, 250);
    },
    onMouseEnter: function onMouseEnter() {
      clearTimeout(timeoutRef.current);
      props.onShow();
    }
  }, /*#__PURE__*/React__default.createElement("ul", null, _renderContextMenuItems()));
}
IlDataTableV3ContextMenu.defaultProps = {
  onShow: function onShow() {
    return null;
  },
  onHide: function onHide() {
    return null;
  }
};

export { IlDataTableV3ContextMenu as default };
